import type { SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';

const searchInputWrapper = (theme: Theme, headerVisibility: boolean): SerializedStyles => css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${theme.zIndex.header};
  transform: translateY(${!headerVisibility ? '-100%' : '0'});
  visibility: ${!headerVisibility ? 'hidden' : 'visible'};
  transition:
    transform 0.3s ease,
    visibility 0.3s ease;
  background-color: inherit;
`;

const truncateText = (_theme: Theme) => css`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
`;

export { searchInputWrapper, truncateText };
